export default __webpack_public_path__ + "static/media/lato.9fafbb14.svg";